import { render, staticRenderFns } from "./CCalendarService.vue?vue&type=template&id=17a5329e&scoped=true"
import script from "./CCalendarService.vue?vue&type=script&lang=ts"
export * from "./CCalendarService.vue?vue&type=script&lang=ts"
import style0 from "./CCalendarService.vue?vue&type=style&index=0&id=17a5329e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a5329e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCard,VHover,VIcon,VImg,VTooltip})
